var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMyProducts = function SvgMyProducts(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108.9 107.4",
    style: {
      enableBackground: "new 0 0 108.9 107.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.myproducts{fill:current;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "myproducts",
    d: "M62,8.5H48.2v16.6H62V8.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "myproducts",
    d: "M62,31.5H48.2V40H62V31.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "myproducts",
    d: "M97.8,31.5V62c-2.1,0.4-3.9,1.4-5.3,3L81.9,76.4l-0.1,0.1v-2.3c0-4.9-4-8.9-8.9-8.9H58.1 c-1.8,0.2-6.7-2.6-8.4-3.2c-7.1-3.3-15.3-3.2-22.2,0.4l-4.3,2.2c-1.1-3.9-4.6-6.5-8.7-6.6h-2.5V31.5h29.7v11.7 c0,1.8,1.4,3.2,3.2,3.2h20.2c1.8,0,3.2-1.4,3.2-3.2V31.5H97.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "myproducts",
    d: "M41.8,25.1H12.1V12.9c0-2.5,1.7-4.4,3.7-4.4h26L41.8,25.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "myproducts",
    d: "M14.6,64.3c1.6,0.2,2.8,1.6,2.7,3.2v28.6c0.1,1.6-1.1,3-2.7,3.2h-5c-1.6-0.2-2.8-1.6-2.7-3.2V67.5 c-0.1-1.6,1.1-3,2.7-3.2H14.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "myproducts",
    d: "M68.4,8.5h26.3c1.7,0,3.1,1.7,3.1,3.7v12.9H68.4V8.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "myproducts",
    d: "M97.1,69.3c2.8-2.8,7.6,0.9,5,4.2L87.7,90.9c-4.9,5.9-12.1,9.3-19.8,9.3H51.6c-6.1,0-12.1-0.7-18-2.1l-9.9-2.4 V71.5l6.7-3.4c5.2-2.6,11.3-2.7,16.6-0.3l5.7,2.7c1.7,0.8,3.5,1.2,5.4,1.2h14.8c1.4,0,2.5,1.1,2.5,2.5V79H46.7 c-1.8-0.1-3.3,1.3-3.4,3c-0.1,1.8,1.3,3.3,3,3.4c0.1,0,0.2,0,0.4,0H76c4,0,7.9-1.7,10.6-4.7L97.1,69.3z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyProducts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MyProducts.945f4b90.svg";
export { ForwardRef as ReactComponent };